import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Google Analytics `page_view` event on every React Router route change.
 * The base gtag.js loader + initial `gtag('config', ...)` with `send_page_view:false`
 * live in /public/index.html — this component only handles SPA navigations.
 */
export default function PageviewTracker() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === lastPath.current) return;
    lastPath.current = path;
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}
